module.exports = __webpack_public_path__ + "img/Champmandi.63bf4f3d.png";